import React from 'react';
import PropTypes from 'prop-types';
import AttachmentModal from '../../../../components/Attachment/AttachmentModal';
import AddDocForm from './add-doc-form';
import './modal.css';

const AddDocModal = ({ contractNumber='', contractLineId, onClose, onSuccess, docType }) => {
  return (
    <AttachmentModal
      id="attachment-add-modal"
      show
      onClose={onClose}
      className="contractline-doc-attachment-modal"
    >
      <AddDocForm
        contractNumber={contractNumber} 
        contractLineId={contractLineId}
        onSuccess={onSuccess}
        onClose={onClose}
        docType={docType}
      />
    </AttachmentModal>
  );
};

AddDocModal.propTypes = {
  contractNumber: PropTypes.string,
  contractLineId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  docType: PropTypes.oneOf(['D', 'I']).isRequired,
};

export default AddDocModal;
